var exports = {
  "i": "xaee3c4fa--8a3817--wrapper",
};

module.exports = exports;
